module.exports = __webpack_public_path__ + "static/media/product1@2x.6b565518.png";